import { Action } from '../../../actions';
import { Progress, DownloadMode, DownloadStatus } from '../reducer';

enum DownloadManagerActionKeys {
	INIT_DOWNLOADS = '@@downloadManager/INIT_DOWNLOADS',
	ADD_ITEM = '@@downloadManager/ADD_ITEM',
	UPDATE_STATUS = '@@downloadManager/UPDATE_STATUS',
	UPDATE_DOWNLOAD = '@@downloadManager/UPDATE_DOWNLOAD',
	SET_REQUEST_ID = '@@downloadManager/SET_REQUEST_ID',
	RECORD_DOWNLOAD_PROGRESS = '@@downloadManager/RECORD_DOWNLOAD_PROGRESS',
	REMOVE_DOWNLOAD = '@@downloadManager/REMOVE_DOWNLOAD',
	SET_DOWNLOAD_ALL_STATUS = '@@downloadManager/SET_DOWNLOAD_ALL_STATUS',
	SET_DELETE_ALL_STATUS = '@@downloadManager/SET_DELETE_ALL_STATUS'
}

interface LocalStorageDownloadInfos {
	id: number;
	status: DownloadStatus;
	mode: DownloadMode;
	version: number;
	dependencies: number[];
	dependents: number[];
}

interface InitDownloadsAction extends Action {
	type: DownloadManagerActionKeys.INIT_DOWNLOADS;
	downloads: LocalStorageDownloadInfos[];
}

interface AddItemAction extends Action {
	type: DownloadManagerActionKeys.ADD_ITEM;
	id: number;
	mode: DownloadMode;
	dependencies: number[];
	dependents: number[];
	version: number;
}

interface UpdateStatusAction extends Action {
	type: DownloadManagerActionKeys.UPDATE_STATUS;
	id: number;
	status: DownloadStatus;
}

interface UpdateDownloadAction extends Action {
	type: DownloadManagerActionKeys.UPDATE_DOWNLOAD;
	id: number;
	mode: DownloadMode;
	dependencies: number[];
	dependents: number[];
	version: number;
}

interface SetRequestIdAction extends Action {
	type: DownloadManagerActionKeys.SET_REQUEST_ID;
	id: number;
	requestId: number;
}

interface RecordDownloadProgressAction extends Action {
	type: DownloadManagerActionKeys.RECORD_DOWNLOAD_PROGRESS;
	id: number;
	progress: Progress;
}

interface SetDownloadAllStatusAction extends Action {
	type: DownloadManagerActionKeys.SET_DOWNLOAD_ALL_STATUS;
	isDownloadingAll: boolean;
}

interface SetDeleteAllStatusAction extends Action {
	type: DownloadManagerActionKeys.SET_DELETE_ALL_STATUS;
	isDeletingAll: boolean;
}

interface RemoveDownloadAction extends Action {
	type: DownloadManagerActionKeys.REMOVE_DOWNLOAD;
	id: number;
}

type DownloadManagerAction = InitDownloadsAction
	| AddItemAction
	| UpdateStatusAction
	| UpdateDownloadAction
	| SetRequestIdAction
	| RecordDownloadProgressAction
	| RemoveDownloadAction
	| SetDownloadAllStatusAction
	| SetDeleteAllStatusAction;


export {
	DownloadManagerActionKeys, DownloadManagerAction, LocalStorageDownloadInfos, SetDownloadAllStatusAction, SetDeleteAllStatusAction,
	InitDownloadsAction, AddItemAction, UpdateStatusAction, UpdateDownloadAction, SetRequestIdAction, RecordDownloadProgressAction, RemoveDownloadAction
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DownloadManager/actions/typings.ts